import { Link } from 'react-router-dom';
import { usePaulAccess, PAUL_AUTHORIZED_EMAIL } from '@/lib/paulAccess';
import { signOut } from '@/lib/auth';

const wrap: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#040414',
  padding: 24,
  fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
};

const btn: React.CSSProperties = {
  display: 'inline-block',
  padding: '10px 18px',
  borderRadius: 10,
  fontSize: 14,
  fontWeight: 600,
  textDecoration: 'none',
  cursor: 'pointer',
  border: '1px solid rgba(255,255,255,0.18)',
};

// Gate for exec/developer-only routes. Instead of silently redirecting (which used to dump
// the user on the dashboard with no explanation), this shows exactly what it sees — so an
// access problem is visible and actionable rather than looking like a broken page.
export function DeveloperRouteGuard({ children }: { children: React.ReactElement }) {
  const { isPaul, isReady, email } = usePaulAccess();

  if (!isReady) {
    return (
      <div style={wrap}>
        <div style={{ color: '#c7cbe0', fontSize: 14 }}>Checking access…</div>
      </div>
    );
  }

  if (!isPaul) {
    return (
      <div style={wrap}>
        <div
          style={{
            maxWidth: 440,
            width: '100%',
            textAlign: 'center',
            color: '#e6e8f5',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 16,
            padding: 28,
            background: '#0b0f26',
          }}
        >
          <div style={{ color: '#f6d24b', fontSize: 12, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 10 }}>
            Thirteen · Exec area
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>Restricted</h1>
          <p style={{ fontSize: 14, color: '#c7cbe0', margin: '0 0 6px' }}>
            This page requires <b>{PAUL_AUTHORIZED_EMAIL}</b> or an admin account.
          </p>
          <p style={{ fontSize: 13, color: '#8b90ab', margin: '0 0 20px' }}>
            {email ? (
              <>You’re signed in as <b>{email}</b> — not authorized here.</>
            ) : (
              <>You’re not signed in.</>
            )}
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to={`/beta?next=${encodeURIComponent(
                typeof window !== 'undefined' ? window.location.pathname : '/timeline-miner',
              )}`}
              style={{ ...btn, background: '#f6d24b', color: '#111', borderColor: 'transparent' }}
            >
              {email ? 'Switch account' : 'Sign in'}
            </Link>
            {email ? (
              <button
                type="button"
                style={{ ...btn, background: 'transparent', color: '#c7cbe0' }}
                onClick={() => {
                  void signOut().finally(() => {
                    window.location.href = '/beta';
                  });
                }}
              >
                Sign out
              </button>
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  return children;
}
